import { getAllDemandData, getAllDocumentsData } from '@src/api/Registration';
import useNavigationStore from '@src/stores/navigationStore';
import useRegistrationStore from '@src/stores/registrationStore';
import { updateRegistrationStoreFromDemand, checkBeneficiariesDocuments } from '@src/utilities/functions';
import { DocumentType } from '@src/utilities/types';
import { useState } from 'react';
import toast from 'react-hot-toast';

export const usePsiUploadsDocuments = () => {
    const { setSection, setBlock } = useNavigationStore();
    const { setField, registration } = useRegistrationStore();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const navigate = (section: number, block: string) => {
        setSection(section);
        setBlock(block);
    }

    const handleNavigationAfterLogin = async (documentsData: any, demandData: any) => {
        if (documentsData?.hasFolder) {
            const hasFront = documentsData.documents?.some((doc: { type: string }) => doc.type === DocumentType.front);
            const hasBack = documentsData.documents?.some((doc: { type: string }) => doc.type === DocumentType.back);
            const hasFrontBack = documentsData.documents?.some((doc: { type: string }) => doc.type === DocumentType.frontBack);
            const hasAddress = documentsData.documents?.some((doc: { type: string }) => doc.type === DocumentType.address);

            const hasBeneficiariesMissingDocuments = checkBeneficiariesDocuments(demandData?.company?.beneficial_owners ?? []);
            return navigate(documentsData.signed_at ? 7 : 6,
                documentsData.signed_at
                    ? 'UploadMissingDocs'
                    : documentsData.signable || (hasFront && hasBack && hasAddress && !hasBeneficiariesMissingDocuments) || (hasFrontBack && hasAddress && !hasBeneficiariesMissingDocuments)
                        ? 'CompanyDocuments'
                        : hasBeneficiariesMissingDocuments
                            ? 'BeneficiariesDocuments'
                            : (hasFront && hasBack) || hasFrontBack
                                ? 'ProofOfAddress'
                                : 'Documents'
            )
        } else {
            return navigate(6, 'Documents');
        }
    };

    const navigateToDemand = async(demandId: string, personId: string): Promise<void> => {
        setIsLoading(true);
        try {
            setField('person_id', personId);
            setField('demand_id', demandId);

            const demandData = await getAllDemandData(demandId);
            const documentsData = await getAllDocumentsData(demandId);
            if (demandData) {
                updateRegistrationStoreFromDemand(demandData, registration, setField);
            }
            if (documentsData && demandData) {
                await handleNavigationAfterLogin(documentsData, demandData);
            }

            return Promise.resolve();
        } catch (error) {
            console.error('Error navigating to demand:', error);
            toast.dismiss();
            toast.error("Une erreur est survenue lors de la récupération des données");
            return Promise.reject(error);
        } finally {
            setIsLoading(false);
        }
    }

    return { navigateToDemand, isLoading };
}
